import Component from '../core/Component'
import EventBus from '../core/EventBus'

export default class LockOpener extends Component {
    prepare() {
        this.element.addEventListener('click', this.handleClick)
        EventBus.on('lock:change', this.handleNavChange)
    }

    handleNavChange = ({ status }) => {
        this.element.classList.toggle('is-open', status)
    }

    handleClick = (event) => {
        event.preventDefault()
        event.stopPropagation()
        Component.getFromElement('lock')?.toggle()
    }
}
